import { Observable } from 'rxjs';
import { addProvider, IProviderDescriptor } from "../ServiceUtil";
import { EmailDelegate } from "./email.delegate";
import { IEmail } from "./email.interface";

export class EmailService
{
    constructor(private emailDelegate: EmailDelegate)
    {

    }

    public senEmail(email: IEmail): Observable<boolean>
    {
        return this.emailDelegate.sendEmail(email);
    }

}